var map = {
	"./icons/Instagram.webp": 8419,
	"./icons/NextPage.webp": 1519,
	"./icons/PrevPage.webp": 309,
	"./icons/QuoteLeft.webp": 4108,
	"./icons/QuoteRight.webp": 3027,
	"./icons/Star.webp": 1366,
	"./icons/bank.webp": 9725,
	"./icons/behance.webp": 2170,
	"./icons/cash.webp": 549,
	"./icons/credit.webp": 4644,
	"./icons/down.webp": 7470,
	"./icons/linkedin.webp": 9059,
	"./icons/location.webp": 5787,
	"./icons/mail.webp": 9304,
	"./icons/marketing.webp": 9679,
	"./icons/menu.webp": 104,
	"./icons/mobile.webp": 4217,
	"./icons/reviews-non-selected.webp": 1706,
	"./icons/reviews-selected.webp": 4478,
	"./icons/sent.webp": 481,
	"./icons/up.webp": 9371,
	"./icons/ux.webp": 5028,
	"./icons/web.webp": 2047,
	"./images/BackgroundImage.webp": 5341,
	"./images/Reviews/ReviewMigracionBudapestAlejandra.webp": 9027,
	"./images/Reviews/ReviewMigracionBudapestSamy.webp": 9815,
	"./images/Reviews/ReviewPanameno.webp": 3908,
	"./images/Reviews/ReviewPiramide.webp": 6766,
	"./images/Reviews/ReviewTravelCalendar.webp": 5405,
	"./images/Reviews/ReviewTravelTribe.webp": 323,
	"./images/Team/MemberLintu.webp": 3650,
	"./images/Team/MemberLuis.webp": 9668,
	"./images/Team/Team.webp": 8160,
	"./images/Team/TeamSection1.webp": 3514,
	"./images/Team/TeamSection2.webp": 1798,
	"./images/Team/TeamSection3.webp": 1721,
	"./images/Team/TeamSection4.webp": 6074,
	"./logo.webp": 8936,
	"./projects/Befoods/Befoods1.webp": 673,
	"./projects/Befoods/Befoods2.webp": 9263,
	"./projects/Befoods/Befoods3.webp": 5427,
	"./projects/Consultoria/Consultoria1.webp": 3865,
	"./projects/IlustracionesDestacados/IlustracionesDestacados1.webp": 1974,
	"./projects/IlustracionesDestacados/IlustracionesDestacados2.webp": 9215,
	"./projects/IlustracionesDestacados/IlustracionesDestacados3.webp": 9527,
	"./projects/InstagramProfiles/InstagramProfiles0.webp": 7829,
	"./projects/InstagramProfiles/InstagramProfiles0Hover.webp": 9326,
	"./projects/InstagramProfiles/InstagramProfiles1.webp": 5962,
	"./projects/InstagramProfiles/InstagramProfiles1Hover.webp": 3677,
	"./projects/InstagramProfiles/InstagramProfiles2.webp": 1715,
	"./projects/LogoSsspeedyRamirez/LogoSsspeedyRamirez1.webp": 2618,
	"./projects/Panameno/Panameno0.webp": 6215,
	"./projects/Panameno/Panameno0Hover.webp": 3376,
	"./projects/Panameno/Panameno1.webp": 6359,
	"./projects/Panameno/Panameno2.webp": 1891,
	"./projects/Panameno/Panameno3.webp": 5562,
	"./projects/Petbacker/Petbacker1.webp": 2492,
	"./projects/Petbacker/Petbacker2.webp": 8307,
	"./projects/Petbacker/Petbacker3.webp": 4488,
	"./projects/PyramidGame/PyramidGame1.webp": 4315,
	"./projects/PyramidGame/PyramidGame2.webp": 9666,
	"./projects/PyramidGame/PyramidGame3.webp": 2769,
	"./projects/Ruteando/Ruteando1.webp": 9844,
	"./projects/Ruteando/Ruteando2.webp": 205,
	"./projects/Ruteando/Ruteando3.webp": 8533,
	"./projects/TravelCalendar/TravelCalendar0.webp": 6861,
	"./projects/TravelCalendar/TravelCalendar0Hover.webp": 2991,
	"./projects/TravelCalendar/TravelCalendar1.webp": 6668,
	"./projects/TravelCalendar/TravelCalendar2.webp": 2203,
	"./projects/TravelCalendar/TravelCalendar3.webp": 2496,
	"./projects/TravelTribe/TravelTribe0.webp": 8399,
	"./projects/TravelTribe/TravelTribe0Hover.webp": 2834,
	"./projects/TravelTribe/TravelTribe1.webp": 4620,
	"./projects/TravelTribe/TravelTribe2.webp": 547,
	"./projects/TravelTribe/TravelTribe3.webp": 1488,
	"./steps/imagestep1.webp": 3430,
	"./steps/imagestep2.webp": 4634,
	"./steps/imagestep3.webp": 3242,
	"./steps/imagestep4.webp": 3958,
	"./steps/imagestep5.webp": 3846,
	"./steps/step1.webp": 2973,
	"./steps/step2.webp": 6967,
	"./steps/step3.webp": 2705,
	"./steps/step4.webp": 5620,
	"./steps/step5.webp": 2794,
	"./techs/AdobeIllustrator.webp": 9758,
	"./techs/AdobePhotoshop.webp": 3564,
	"./techs/Android.webp": 519,
	"./techs/AngularJS.webp": 7048,
	"./techs/CSS.webp": 2643,
	"./techs/Django.webp": 3781,
	"./techs/Docker.webp": 3017,
	"./techs/Domain.webp": 2546,
	"./techs/Expo.webp": 3047,
	"./techs/Figma.webp": 5039,
	"./techs/Flask.webp": 7804,
	"./techs/GitHub.webp": 7322,
	"./techs/GooglePlayStore.webp": 4850,
	"./techs/HTML.webp": 3266,
	"./techs/Hosting.webp": 1997,
	"./techs/Javascript.webp": 8576,
	"./techs/Miro.webp": 2118,
	"./techs/NodeJS.webp": 9391,
	"./techs/Notion.webp": 1620,
	"./techs/Python.webp": 5853,
	"./techs/ReactJS.webp": 700,
	"./techs/ReactNative.webp": 5219,
	"./techs/SQL.webp": 2452,
	"./techs/Sass.webp": 5196,
	"./techs/Sketch.webp": 6993,
	"./techs/Typescript.webp": 2890,
	"./techs/Zoom.webp": 3868
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3085;